import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// react imports
import React from 'react';
// import components
import { CmAlertDialog } from '@codametrix/ui-components';
import { PatientEncounterDashboardColumns } from '@codametrix/ui-common';
import { PatientEncounter, Notes, EmptyNote } from '@codametrix/shared-views';
import { Conditional, LoadingSlugs } from '@codametrix/ui-components';
// import styles
import './generic-related-modal.scss';
const fieldEditorInfo = {
    caseEdits: {
        caseEdits: {}
    },
    updateValue: (val)=>console.log(val),
    updateCase: (val)=>console.log(val)
};
/**
 * GenericRelatedModal component
 * @param {ModalProps} modalProps - Props for GenericRelatedModal component
 * @returns {React.FC} - React functional component
 */ export const GenericRelatedModal = (modalProps)=>{
    return /*#__PURE__*/ _jsx(CmAlertDialog, {
        isOpen: modalProps.isOpen,
        onClose: modalProps.handleClose,
        title: modalProps.modalHeader,
        leastDestructiveRef: modalProps.leastDestructiveRef,
        showCloseButton: modalProps.showCloseIcon !== false,
        maxW: modalProps.width ?? '95vw',
        blockScrollOnMount: false,
        variant: "wide",
        contentClassName: `generic-cases-modal ${modalProps?.className ?? ''}`,
        contentTestId: modalProps.contentTestId,
        footer: modalProps.modalFooter,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "main-view",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "merge-actions-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "encounter-content",
                            children: /*#__PURE__*/ _jsx(Conditional, {
                                every: [
                                    !!modalProps?.includePatientEncounter,
                                    !!modalProps?.activeCaseRun
                                ],
                                children: /*#__PURE__*/ _jsx(PatientEncounter, {
                                    propertyConfig: PatientEncounterDashboardColumns.patientTimeline,
                                    fieldEditorInfo: fieldEditorInfo,
                                    activeItem: modalProps?.activeCaseRun ?? {}
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "main-content",
                            children: modalProps.modalContent
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "note-section",
                    children: [
                        /*#__PURE__*/ _jsx(Conditional, {
                            every: [
                                modalProps.loadingNotes === true
                            ],
                            children: /*#__PURE__*/ _jsx(LoadingSlugs, {
                                numberItems: 7
                            })
                        }),
                        /*#__PURE__*/ _jsx(Conditional, {
                            every: [
                                !modalProps?.htmlNotes?.length,
                                !modalProps.notes?.length,
                                modalProps.loadingNotes !== true
                            ],
                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Conditional, {
                                        every: [
                                            !!modalProps?.activeCaseRun?.note_unavailable_reason
                                        ],
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "note-unavaialable",
                                            children: modalProps?.activeCaseRun?.note_unavailable_reason ?? 'No documentation available.'
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Conditional, {
                                        every: [
                                            !modalProps?.activeCaseRun?.note_unavailable_reason
                                        ],
                                        children: /*#__PURE__*/ _jsx(_Fragment, {
                                            children: /*#__PURE__*/ _jsx(EmptyNote, {})
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Conditional, {
                            every: [
                                !!modalProps.notes?.length,
                                modalProps.loadingNotes !== true
                            ],
                            children: /*#__PURE__*/ _jsx(Notes, {
                                notes: modalProps.notes
                            })
                        })
                    ]
                })
            ]
        })
    });
};
